<template>
    <div class="inline-flex">
        <div class="h-1 rounded-lg w-5"
            :class="[ (level < levels) ? 'mr-2' : '', (level <= currentLevel) ? 'bg-gray-100' : 'bg-black-transparent-25' ]"
            v-for="level in levels">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        levels: Number,
        currentLevel: Number,
    },
};
</script>
